/**
 * Reads the binary content of a file object and returns it as a promise.
 *
 * @async
 * @throws {Error}
 *
 * @param {File} file - The file object to read as binary content.
 * @returns {Promise<string>} - A promise that resolves with the binary content of the file.
 */
export default async function (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const binaryFile = reader.result;
      resolve(binaryFile);
    });
    reader.addEventListener('error', (error) => {
      reject(error);
    });
    reader.readAsBinaryString(file);
  });
}
